<template>
  <div class="menu-wrapper" ref="menuWrapper">
    <template v-for="item in jcd">
      <el-submenu v-if="item.children" :index="item.id" :key="item.id">
        <template slot="title">
          <!-- 修复：使用完整的路由路径 -->
          <router-link
            :to="{
              path: '/MonitorPoint/MonitorPoint',
              query: { id: item.mpID },
            }"
            style="height: 50px; width: 100%; display: inline-block"
            @click.native="handleTitleClick($event, item)"
          >
            <span style="color: black" class="icon iconfont jc">&#xe606;</span>
            <span style="color: black;" v-if="language=='en-US'">{{ item.title_ENG }}</span>
             <span style="color: black;" v-else>{{ item.title }}</span>
            <!-- 添加排序手柄 -->
            <!-- 添加排序手柄 -->
            <!-- <span class="drag-handle" @mousedown.stop>
              <i class="el-icon-rank"></i>
            </span> -->
          </router-link>
        </template>

        <!-- 修复子菜单项的路由index -->
        <template v-for="child in item.children">
          <el-submenu
            class="menu-type"
            :index="child.id"
            :key="child.id"
            v-if="child.children"
            :data-draggable="false"
          >
            <template slot="title">
              <span style="color: black;" v-if="language=='en-US'">{{ child.title_ENG }}</span>
              <span v-else>{{ child.title }}</span>
              <!-- <span class="drag-handle" @mousedown.stop>
                <i class="el-icon-rank"></i>
              </span> -->
            </template>

            <template v-for="childn in child.children">
              <el-submenu
                class="menu-type"
                :index="childn.id"
                :key="childn.id"
                v-if="childn.children"
                :data-draggable="false"
              >
                <template slot="title">
                  <!-- <span class="drag-handle" @mousedown.stop>
                    <i class="el-icon-rank"></i>
                  </span> -->
                  <!-- 内容保持不变 -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="childn.title"
                    placement="top-start"
                    v-if="
                      childn.title == '土壤温度水分变送器RS-WS-N01-TR-1' ||
                      childn.title == '高精度深层水平位移EA-DHL4Pro'
                    "
                  >
                    <span
                      class="drag-handle"
                      @mousedown.stop
                      v-if="language=='en-US'"
                      style="
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        display: inline-block;
                        width: 100px;
                      "
                      >{{ childn.title_ENG }}</span>
                       <span
                       v-else
                      class="drag-handle"
                      @mousedown.stop
                      style="
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        display: inline-block;
                        width: 100px;
                      "
                      >{{ childn.title }}</span

                    >
                  </el-tooltip>

                  <span class="drag-handle" @mousedown.stop v-else>
                    <span    v-if="language=='en-US'">  {{childn.title_ENG}}</span>
                    <span    v-else>{{ childn.title }}</span>
                  </span>
                </template>

                <!-- 修复：使用完整的路由路径作为index -->
                <template v-for="childns in childn.children">
                  <el-menu-item
                    class="menu-mpID leaf-node"
                    :index="
                      '/MonitorPoint/MonitorPointProject/' +
                      childn.title +
                      '/' +
                      encodeURIComponent(childns.title) +
                      '/' +
                      childns.mpID
                    "
                    :key="childns.mpID"
                    :class="{ 'is-active': isActiveItem(childns) }"
                    v-if="childns.monitorPointInfo_remark"
                    :data-draggable="true"
                    :data-menu-id="childns.mpID"
                  >
                    <!-- <span class="drag-handle" @mousedown.stop>
                      <i class="el-icon-rank"></i>
                    </span> -->
                    <el-tooltip
                      v-if="childns.monitorPointInfo_remark"
                      class="item"
                      effect="dark"
                      :content="childns.monitorPointInfo_remark"
                      placement="right-start"
                    >
                      <template #title>
                        <span class="drag-handle" @mousedown.stop>{{
                          childns.monitorPointInfo_remark
                        }}</span>
                      </template>
                    </el-tooltip>
                  </el-menu-item>
                  <el-menu-item
                    class="menu-mpID leaf-node"
                    :index="
                      '/MonitorPoint/MonitorPointProject/' +
                      childn.title +
                      '/' +
                      encodeURIComponent(childns.title) +
                      '/' +
                      childns.mpID
                    "
                    :key="childns.mpID"
                    :class="{ 'is-active': isActiveItem(childns) }"
                    v-else
                    :data-draggable="true"
                    :data-menu-id="childns.mpID"
                  >
                    <!-- <span class="drag-handle" @mousedown.stop>
                      <i class="el-icon-rank"></i>
                    </span> -->
                    <template #title>
                      <span class="drag-handle" @mousedown.stop>{{
                        childns.monitorPointInfo_remark
                      }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </el-submenu>

              <!-- 修复视觉位移相关的菜单项 -->
              <template v-else>
                <el-tooltip
                  v-if="childn.monitorPointInfo_remark"
                  class="item"
                  effect="dark"
                  :content="childn.monitorPointInfo_remark"
                  placement="right-start"
                >
                  <el-menu-item
                    class="menu-mpID leaf-node"
                    :index="
                      '/MonitorPoint/viewjue/' +
                      child.title +
                      '/' +
                      encodeURIComponent(childn.title) +
                      '/' +
                      childn.mpID
                    "
                    v-if="
                      childn.monitorPointInfo_remark &&
                      child.title == '视觉位移'
                    "
                    :key="childn.mpID"
                    :class="{ 'is-active': isActiveItem(childn) }"
                    :data-draggable="true"
                    :data-menu-id="childn.mpID"
                  >
                    <!-- <span class="drag-handle" @mousedown.stop>
                      <i class="el-icon-rank"></i>
                    </span> -->
                    <template #title>
                      <span class="drag-handle" @mousedown.stop>{{
                        childn.monitorPointInfo_remark
                      }}</span>
                    </template>
                  </el-menu-item>
                </el-tooltip>

                <el-tooltip
                  v-if="childn.monitorPointInfo_remark"
                  class="item"
                  effect="dark"
                  :content="childn.monitorPointInfo_remark"
                  placement="right-start"
                >
                  <el-menu-item
                    class="menu-mpID leaf-node"
                    :index="
                      '/MonitorPoint/MonitorPointProject/' +
                      child.title +
                      '/' +
                      encodeURIComponent(childn.title) +
                      '/' +
                      childn.mpID
                    "
                    v-if="
                      childn.monitorPointInfo_remark &&
                      child.title != '视觉位移'
                    "
                    :key="childn.mpID"
                    :class="{ 'is-active': isActiveItem(childn) }"
                    :data-draggable="true"
                    :data-menu-id="childn.mpID"
                  >
                    <!-- <span class="drag-handle" @mousedown.stop>
                      <i class="el-icon-rank"></i>
                    </span> -->
                    <template #title>
                      <span class="drag-handle" @mousedown.stop>{{
                        childn.monitorPointInfo_remark
                      }}</span>
                    </template>
                  </el-menu-item>
                </el-tooltip>

                <el-menu-item
                  class="menu-mpID leaf-node"
                  :index="
                    '/MonitorPoint/viewjue/' +
                    child.title +
                    '/' +
                    encodeURIComponent(childn.title) +
                    '/' +
                    childn.mpID
                  "
                  v-if="
                    !childn.monitorPointInfo_remark && child.title == '视觉位移'
                  "
                  :key="childn.mpID"
                  :class="{ 'is-active': isActiveItem(childn) }"
                  :data-draggable="true"
                  :data-menu-id="childn.mpID"
                >
                  <!-- <span class="drag-handle" @mousedown.stop>
                    <i class="el-icon-rank"></i>
                  </span> -->
                  <template #title>
                    <span class="drag-handle" @mousedown.stop v-if="language=='en-US'">{{
                      childn.title_ENG
                    }}</span>
                    <span class="drag-handle" @mousedown.stop  v-else>{{
                      childn.title
                    }}</span>
                  </template>
                </el-menu-item>

                <el-menu-item
                  class="menu-mpID leaf-node"
                  :index="
                    '/MonitorPoint/MonitorPointProject/' +
                    child.title +
                    '/' +
                    encodeURIComponent(childn.title) +
                    '/' +
                    childn.mpID
                  "
                  v-if="
                    !childn.monitorPointInfo_remark && child.title != '视觉位移'
                  "
                  :key="childn.mpID"
                  :class="{ 'is-active': isActiveItem(childn) }"
                  :data-draggable="true"
                  :data-menu-id="childn.mpID"
                >
                  <!-- <span class="drag-handle" @mousedown.stop>
                    <i class="el-icon-rank"></i>
                  </span> -->
                  <template #title>
                    <!-- <span class="drag-handle" @mousedown.stop>{{
                      childn.title
                    }}</span> -->
                         <span class="drag-handle" @mousedown.stop v-if="language=='en-US'">{{
                      childn.title_ENG
                    }}</span>
                    <span class="drag-handle" @mousedown.stop  v-else>{{
                      childn.title
                    }}</span>
                  </template>
                </el-menu-item>
              </template>
            </template>
          </el-submenu>

          <template v-else>
            <el-menu-item
              :index="child.id"
              :key="child.id"
              :data-draggable="false"
              :data-menu-id="child.id"
            >
              <!-- <span class="drag-handle" @mousedown.stop>
                <i class="el-icon-rank"></i>
              </span> -->
              <template slot="title">
                <!-- <span class="drag-handle" @mousedown.stop>{{
                  child.title
                }}</span> -->

                    <span class="drag-handle" @mousedown.stop v-if="language=='en-US'">{{
                      child.title_ENG
                    }}</span>
                    <span class="drag-handle" @mousedown.stop  v-else>{{
                      child.title
                    }}</span>
              </template>
            </el-menu-item>
          </template>

          <!-- 其他菜单项保持不变 -->
        </template>
      </el-submenu>
    </template>

    <el-submenu index="'-7'" v-if="mainSystem" :data-draggable="false">
      <template slot="title">
        <span class="icon iconfont rw">&#xe684;</span>
        <span>{{ $t('route.task') }}</span>
      </template>
      <el-menu-item :index="'/Task/Task'" :data-draggable="false">
        <template slot="title">
          <span>{{ $t('route.caiji') }}</span>
        </template>
      </el-menu-item>
      <el-menu-item :index="'/Task/DTUList'" :data-draggable="false">
        <template slot="title">
          <span>{{ $t('route.dtuTask') }}</span>
        </template>
      </el-menu-item>
    </el-submenu>

    <template v-if="!(!mainSystem && show)">
      <el-menu-item
        :key="'/yujing/yujing'"
        :index="'/yujing/yujing'"
        :data-draggable="false"
      >
        <span
          ><img
            src="../../../assets/预警推送logo.png"
            alt=""
            style="width: 20px; margin-right: 10px; margin-top: -10px"
        /></span>
        <span slot="title" style="color: black">{{ $t('route.warning') }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "../bus";
import Sortable from "sortablejs";

export default {
  name: "Content",
  data() {
    return {
      MenuRouter: [],
      jcd: [],
      title1: "预警推送",
      show: false,
      childzizhanghao: "",
      arrlist: [],
      language:'',
      activeIndex: "", // 添加activeIndex来跟踪激活项
      sortable: null, // Sortable实例
      dragConfig: {
        animation: 150, // 动画时长
        ghostClass: "sortable-ghost", // 拖拽占位符样式
        chosenClass: "sortable-chosen", // 选中项样式
        dragClass: "sortable-drag", // 拖拽项样式
        handle: ".drag-handle", // 拖动手柄
        filter: '[data-draggable="false"], .el-submenu', // 不可拖拽的元素
        group: {
          name: "leaf-menu", // 同级最后一级分组，确保只在同级拖拽
          pull: true,
          put: true,
        },
        preventOnFilter: true,
        draggable: ".leaf-node",
        onStart: this.onDragStart,
        onEnd: this.onDragEnd,
        onUpdate: this.onDragUpdate,
        onSort: this.onDragSort,
      },
    };
  },
  computed: {
    ...mapGetters(["prjID", "mainSystem"]),
    // 计算当前路由路径
    currentRoutePath() {
      return this.$route.path;
    },
  },
  watch: {
    // 监听路由变化
    "$route.path": {
      handler(newPath) {
        this.activeIndex = newPath;
        this.updateActiveState();
      },
      immediate: true,
    },
    // 监听菜单数据加载完成
    jcd: {
      handler() {
        this.$nextTick(() => {
          this.updateActiveState();
          this.initSortable();
        });
      },
      deep: true,
    },
    prjID: function () {
      this.loadData();
    },
      // ✅ 监听语言变化
    '$i18n.locale': function() {
      this.$forceUpdate()
    }
  },
  methods: {
    // 初始化拖拽排序
    initSortable() {
      if (this.sortable) {
        this.sortable.destroy();
      }

      const menuWrapper = this.$refs.menuWrapper;
      if (!menuWrapper) return;

      const leafMenus = this.$el.querySelectorAll(".menu-mpID"); // 最后一级的 class
      leafMenus.forEach((leafMenu) => {
        this.sortable = Sortable.create(leafMenu.parentNode, {
          // 父级是 el-submenu 的 el-menu
          ...this.dragConfig,
          group: "leaf-menu", // 同级分组
        });
      });

      // 初始化子菜单的拖拽
      this.initSubMenuSortable();
    },

    // 初始化子菜单的拖拽
    initSubMenuSortable() {
      const submenus = this.$el.querySelectorAll(".el-submenu .el-menu");
      submenus.forEach((submenu) => {
        Sortable.create(submenu, {
          ...this.dragConfig,
          group: "submenu-sortable",
          onStart: this.onDragStart,
          onEnd: this.onDragEnd,
          onUpdate: this.onDragUpdate,
          onSort: this.onDragSort,
        });
      });
    },

    // 拖拽开始
    onDragStart(evt) {
      evt.item.classList.add("sortable-dragging");
    },

    // 拖拽结束
    onDragEnd(evt) {
      evt.item.classList.remove("sortable-dragging");
    },

    // 拖拽更新
    onDragUpdate(evt) {
      this.updateMenuOrder();
    },

    // 拖拽排序
    onDragSort(evt) {
      // this.updateMenuOrder();
    },

    // 更新菜单顺序
    updateMenuOrder() {
      const menuItems = this.$el.querySelectorAll(
        '[data-menu-id][data-draggable="true"]'
      );
      const newOrder = [];
      menuItems.forEach((item) => {
        const menuId = item.getAttribute("data-menu-id");
        if (menuId) newOrder.push(menuId);
      });
      this.reorderMenuData(newOrder); // 重排数据（需实现）
      this.saveMenuOrder(); // 保存顺序
    },

    // 根据新顺序重新组织菜单数据
    // reorderMenuData(newOrder) {
    //   if (!newOrder.length) return;

    //   // 这里需要根据你的数据结构调整排序逻辑
    //   // 由于你的数据结构比较深，这里提供一种思路：

    //   // 1. 扁平化菜单数据
    //   const flatMenu = this.flattenMenu(this.jcd);

    //   // 2. 根据newOrder重新排序
    //   const sortedMenu = [];
    //   newOrder.forEach((id) => {
    //     const menuItem = flatMenu.find((item) => item.mpID == id);
    //     if (menuItem) {
    //       sortedMenu.push(menuItem);
    //     }
    //   });

    //   // 3. 重新构建树形结构（这里需要根据你的实际数据结构调整）
    //   // 由于时间关系，这里只提供思路
    //   console.log("新顺序:", newOrder);
    //   console.log("排序后的菜单:", sortedMenu);
    //   let sarry = [];
    //   var b = "";
    //   sortedMenu.map((item) => {
    //     sarry.push(item.mpID);
    //   });
    //   b = sarry.join(",");
    //   console.log(b);

    //   // 触发排序完成事件
    //   this.$emit("menu-sorted", newOrder);
    // },

     reorderMenuData(newOrder) {
    const flatMenu = this.flattenMenu(this.jcd); // 扁平化菜单
    const sortedMenu = [];
    newOrder.forEach(id => {
      const menuItem = flatMenu.find(item => item.mpID == id);
      if (menuItem) sortedMenu.push(menuItem);
    });
    // 重新构建树形结构（需根据实际数据结构调整）
    console.log('新顺序：', newOrder);
    console.log('排序后：', sortedMenu);
         let sarry = [];
      var b = "";
      sortedMenu.map((item) => {
        sarry.push(item.mpID);
      });
      b = sarry.join(",");
      console.log(b);

        this.$api.post("monitorPoint/setMonitorPointSort", { data: b }).then((r) => {
          console.log(r)
          if (r.state=='0') {
            // this.loadData()
          }
        })

  },

    // 扁平化菜单数据
  flattenMenu(menu) {
    const result = [];
    const flatten = (items) => {
      items.forEach(item => {
        result.push(item);
        if (item.children && item.children.length) flatten(item.children);
      });
    };
    if (Array.isArray(menu)) flatten(menu);
    return result;
  },

    // 保存排序到本地存储
    saveMenuOrder() {
      const menuWrapper = this.$refs.menuWrapper;
      if (!menuWrapper) return;

      const order = [];
      Array.from(menuWrapper.children).forEach((child) => {
        if (child.getAttribute("data-menu-id")) {
          order.push(child.getAttribute("data-menu-id"));
        }
      });

      localStorage.setItem("menu-order", JSON.stringify(order));
    },

    // 从本地存储加载排序
    loadMenuOrder() {
      const savedOrder = localStorage.getItem("menu-order");
      if (savedOrder) {
        try {
          return JSON.parse(savedOrder);
        } catch (e) {
          console.error("加载菜单排序失败:", e);
        }
      }
      return null;
    },

    // 检查菜单项是否激活
    isActiveItem(item) {
      if (!item) return false;

      // 根据不同的路由模式检查
      const currentPath = this.$route.path;
      const itemPath = this.getItemPath(item);

      return currentPath === itemPath;
    },

    // 获取菜单项对应的路由路径
    getItemPath(item) {
      // 这里需要根据你的路由规则来生成路径
      // 根据你的代码逻辑调整
      if (item.parentTitle === "视觉位移") {
        return `/MonitorPoint/viewjue/${item.parentTitle}/${encodeURIComponent(
          item.title
        )}/${item.mpID}`;
      } else {
        return `/MonitorPoint/MonitorPointProject/${
          item.parentTitle
        }/${encodeURIComponent(item.title)}/${item.mpID}`;
      }
    },

    // 更新激活状态
    updateActiveState() {
      this.activeIndex = this.$route.path;
    },

    // 处理标题点击
    handleTitleClick(event, item) {
      event.stopPropagation();
      // 记录激活的菜单项
      this.activeIndex = `/MonitorPoint/MonitorPoint?id=${item.mpID}`;
    },

    loadData() {
      // 原有的loadData方法
          this.language = localStorage.getItem('language')
          console.log('1222222','nihao,', this.language)
      this.arrlist = [];
      this.$api.post("/menu", { prjID: this.prjID }).then((r) => {
        this.$nextTick(() => {
          this.MenuRouter = r.PrjMenu[0];
          localStorage.setItem("hhhh", JSON.stringify(r.PrjMenu));
          this.jcd = [];
          localStorage.setItem("prjID", r.PrjMenu[0].prjID);
          if (r.PrjMenu[0].children.length != 0) {
            this.jcd.push(r.PrjMenu[0].children[0]);
            this.arrlist.unshift(this.jcd[0].id);
            this.$emit("zishuju", this.arrlist);
          }
          this.$emit("projectName", r.PrjMenu[0]);

          // 数据加载完成后更新激活状态
          setTimeout(() => {
            this.updateActiveState();
            this.initSortable();
          }, 100);
        });
      });
    },

    nidhi() {
      console.log("1111");
    },
    liqi() {
      console.log("2222");
    },
  },
  mounted() {
    // 先安装sortablejs依赖
    // npm install sortablejs --save

    setTimeout(() => {
      this.loadData();
    }, 1000);
    window.addEventListener('locale-changed', () => {
      this.$forceUpdate()
    })

    this.childzizhanghao = localStorage.getItem("company");
     EventBus.$on('call-component-b', this.loadData)
    console.log(this.childzizhanghao);
    if (this.childzizhanghao == "ChildUsers") {
      this.show = true;
    } else {
      this.show = false;
    }
  },
  beforeDestroy() {
    // 清理Sortable实例
    if (this.sortable) {
      this.sortable.destroy();
    }
     window.removeEventListener('locale-changed', () => {
      this.$forceUpdate()
    })
  },
};
</script>

<style scoped>
/* 修复样式优先级问题 */
.jc {
  font-size: 26px;
}
.rw {
  display: inline-block;
  font-size: 24px;
  margin-top: -4px;
}
a {
  text-decoration: none;
}

/* 拖拽手柄样式 */
.drag-handle {
  display: inline-block;
  margin-left: -10px;
  cursor: move;
  color: #070707;
  opacity: 0.9;
  transition: opacity 0.3s;
  font-size: 14px;
  width: 22px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  border-radius: 3px;
}

.drag-handle:hover {
  opacity: 1;
  /* background-color: #f5f7fa; */
}

.drag-handle i {
  transform: rotate(90deg);
}

/* 拖拽时的样式 */
.sortable-ghost {
  opacity: 0.4;
  background-color: #f0f7ff;
}

.sortable-chosen {
  background-color: #f5f7fa;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.sortable-drag {
  opacity: 0.8;
  transform: rotate(3deg);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.sortable-dragging {
  background-color: #e6f7ff;
}

/* 确保激活状态样式优先级最高 */
>>> .el-menu-item.is-active {
  background-color: #cdd7e0 !important;
  color: #0d3a61 !important;
  font-weight: bold;
}

/* 添加激活状态的边框或指示器 */
>>> .el-menu-item.is-active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #0d3a61;
}

/* 确保悬停样式不会覆盖激活样式 */
>>> .el-menu-item:hover:not(.is-active) {
  background: #e2e9f3 !important;
}

/* 子菜单激活状态 */
>>> .menu-mpID.is-active {
  background-color: #cdd7e0 !important;
  color: #0d3a61 !important;
}

/* 修复路由链接样式 */
a.router-link-active .el-menu-item {
  background-color: #cdd7e0 !important;
  color: #0d3a61 !important;
}

/* 添加点击效果 */
>>> .el-menu-item:active {
  background-color: #b8c6d0 !important;
  transition: background-color 0.1s;
}

/* 调整菜单项样式，为拖动手柄留出空间 */
>>> .el-menu-item,
>>> .el-submenu__title {
  position: relative;
  padding-right: 40px !important;
}

>>> .el-menu-item .drag-handle,
>>> .el-submenu__title .drag-handle {
  position: absolute;
  /* right: 50%; */
  /* left:6%; */
  top: 50%;
  transform: translateY(-50%);
}
</style>


// WEBPACK FOOTER //
// src/components/Layout/Sidebar/Content.vue